import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import Dealer1 from '../../../assets/motorcycle-financing/motorcycle-dealer1.png'
import Dealer2 from '../../../assets/motorcycle-financing/motorcycle-dealer2.png'
import Dealer3 from '../../../assets/motorcycle-financing/motorcycle-dealer3.png'
import { ROOT_PATH} from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppOurDealer: React.FC = () => {
    const { t } = useTranslation()
    const data = [
        {
            'image': Dealer1,
            'title': 'G C ANN MOTOR ENTERPRISE SDN BHD (HQ)',
            'content': 'NO 4,6 & 8, JALAN MELATI 3/1, BANDAR MELAWATI, SELANGOR',
            'tel': '+01111037888',
        },
        {
            'image': Dealer2,
            'title': 'WANG MAJU MOTOR SDN BHD',
            'content': 'LOT 1, 2, 3 & 4, BLOCK B, KAMPUNG NAMBAZAN, JALAN PENAMPUNG - KINARUT / PAPAR OLD HIGHWAY, PENAMPANG, SABAH',
            'tel': '+088715696',
        },
        {
            'image': Dealer3,
            'title': 'EE TIONG MOTORSPORT SDN BHD',
            'content': '383-390, JALAN PAHANG, SETAPAK, WP KUALA LUMPUR',
            'tel': '+0340253906',
        },
    ]

    const renderDealerItem = (index: number) => {
        return (
            <Box sx={{
                width: '100%',
                height: '100%',
                borderRadius: 6,
                paddingBottom: '40px',
            }}>
                <Image style={{borderRadius: '10px',}} src={data[index]['image']}  alt='' preview={false} ></Image>
                <Typography fontWeight={700} fontSize={'20px'} color={'#6B6B6B'} sx={{
                    paddingTop: '24px'
                }}>
                    {data[index]['title']}
                </Typography>
                <Typography fontWeight={400} fontSize={'14px'} color={'#6B6B6B'} sx={{
                    paddingTop: '6px'
                }}>
                    {data[index]['content']}
                </Typography>
                <Typography fontWeight={400} fontSize={'14px'} color={'#6B6B6B'} sx={{
                    paddingTop: '6px'
                }}>
                    Tel:{data[index]['tel']}
                </Typography>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            backgroundColor: '#FFFFFF',
            paddingLeft: '12px',
            paddingRight: '12px',
            paddingTop: '30px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <Typography fontWeight={700} fontSize={'28px'} color={'#141F39'}>
                    {t('t203')}
                </Typography>

                <Box onClick={()=>{window.location.replace(ROOT_PATH + '/our-dealer')}} sx={{
                    cursor: 'pointer'
                }}>
                    <Typography fontWeight={600} fontSize={'18px'} color={'#6B6B6B'}>
                        {t('t204')}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                paddingTop: '20px',
                paddingBottom: '60px',
            }}>
                {(data.map((item, index) => (
                    renderDealerItem(index)
                )))}
            </Box>

        </Box>
    )
}

// ======================= EXPORT
export default SMAppOurDealer
